import { takeEvery, put, select } from 'redux-saga/effects';

import ordersListActions from '../actionTypes/ordersListActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { GET_ORDERS_URL } from '../routes';
import { ROLES } from '../globalConstants';
import dateTimeHelpers from '../utils/dateTimeHelpers';

const getDefaultFilters = (state) => {
  switch (state.loginReducer.currentUser.role) {
    case ROLES.company_admin:
      return {
        company_ids: [state.loginReducer.currentUser.resourceable_id],
        employee_ids: [state.loginReducer.currentUser.id],
      };
    case ROLES.restaurant_admin:
      return { restaurant_ids: [state.currentRestaurant.id] };
    case ROLES.employee:
      return { employee_ids: [state.loginReducer.currentUser.id] };
    default:
      return {};
  }
};

function* getOrdersList({ payload }) {
  const defaultFilters = yield select(getDefaultFilters);

  const formattedDateFilters =
    payload && payload.filters && payload.filters.from
      ? {
          from: dateTimeHelpers.formatDate(payload.filters.from),
          to: dateTimeHelpers.formatDate(payload.filters.to),
        }
      : null;

  yield put({
    type: API_CALL,
    payload: {
      url: GET_ORDERS_URL,
      method: 'POST',
      data: {
        ...payload,
        filters: {
          ...defaultFilters,
          ...payload.filters,
          ...formattedDateFilters,
        },
      },
    },
    successAction: ordersListActions.getOrdersListSuccess,
    failureAction: ordersListActions.getOrdersListFailed,
  });
}

export default function* watchOrdersList() {
  yield takeEvery(ordersListActions.getOrdersList, getOrdersList);
}
